import React from "react";
import { Grid, Box, Typography, } from "@mui/material";

import ModuleShipmentCard from './ModuleShipmentCard'


const ModuleShipementPipelineSteps = ({stepName, stepColor, stepID, shipements, transporst, filterData}) => {
    return (
        <>
            <Grid item xs={12} sm={6} md={3}>

                <Box sx={{
                    backgroundColor: 'rgba(134,132,122,0.1)',
                    borderLeft: `1px solid`,
                    borderLeftColor: stepColor,
                    minWidth: '250px',

                }}>
                    <Typography variant='h7' component="h5" sx={{ p: 2 }}>
                        {stepName}
                    </Typography>

                    <ModuleShipmentCard stepID={stepID} shipements={shipements} transporst={transporst} filterData={filterData} />

                </Box>
            </Grid>
        </>
    );
}

export default ModuleShipementPipelineSteps;
